import type { FC, ReactNode } from 'react'
import type { FestiveColor } from '@/types'

import { cn } from '@/lib/utils'
import SectionHeading from '@/components/landing/section-heading'
import { invitation } from '@/constants/invitation'

const TILE_CLASSES: Record<FestiveColor, string> = {
    saffron: 'bg-festive-saffron text-foreground',
    raspberry: 'bg-festive-raspberry text-primary-foreground',
    teal: 'bg-festive-teal text-foreground',
    lilac: 'bg-festive-lilac text-foreground',
    coral: 'bg-festive-coral text-foreground',
    blush: 'bg-festive-blush text-foreground'
}

const ProgramSection: FC = (): ReactNode => {
    return (
        <section id='programme' aria-labelledby='programme-titre' className='bg-muted py-24 sm:py-32'>
            <div className='mx-auto max-w-6xl px-5 sm:px-8'>
                <SectionHeading
                    id='programme-titre'
                    align='center'
                    eyebrow="Le programme"
                    title="Le déroulé de la soirée"
                    description="Une soirée pensée pour profiter de chaque instant, du premier verre à la dernière danse."
                />

                <div className='relative mt-16 sm:mt-20'>
                    <span aria-hidden='true' className='absolute top-2 bottom-2 left-7 border-l-2 border-dashed border-foreground/15 md:hidden' />
                    <span aria-hidden='true' className='absolute top-7 right-[10%] left-[10%] hidden border-t-2 border-dashed border-foreground/15 md:block' />

                    <ol className='relative grid gap-10 md:grid-cols-5 md:gap-6'>
                        {invitation.program.map(item => {
                            const Icon = item.icon

                            return (
                                <li key={item.time} className='flex gap-5 md:flex-col md:items-center md:text-center'>
                                    <span
                                        className={cn(
                                            'relative grid size-14 shrink-0 place-items-center rounded-2xl shadow-md ring-4 ring-muted',
                                            TILE_CLASSES[item.color]
                                        )}
                                    >
                                        <Icon className='size-6' aria-hidden='true' />
                                    </span>

                                    <div className='pt-1 md:pt-0'>
                                        <p className='font-heading text-2xl leading-none text-primary'>
                                            {item.time}
                                        </p>

                                        <h3 className='mt-2 text-lg font-bold'>
                                            {item.title}
                                        </h3>

                                        <p className='mt-1.5 text-sm leading-relaxed text-muted-foreground'>
                                            {item.description}
                                        </p>
                                    </div>
                                </li>
                            )
                        })}
                    </ol>
                </div>
            </div>
        </section>
    )
}

export default ProgramSection
